import { useTranslation } from 'react-i18next';
import { showsData as staticShows } from '../data/shows';
import { fetchShows, parseBi, biText } from '../lib/api';
import { useSupabaseData } from '../lib/useSupabaseData';
import { FaAward } from 'react-icons/fa';
import { Reveal, RevealHeading } from '../components/Reveal';

const ShowsPage = () => {
  const { t, i18n } = useTranslation();
  const { data: showsData } = useSupabaseData(fetchShows, staticShows, 'shows');

  const lang = i18n.language === 'en' ? 'en' : 'pl';
  // Obsłuż oba kształty: obiekt {pl,en} (z bazy) i zwykły tekst (dane zapasowe)
  const L = (v) => biText(parseBi(v), lang);

  const groupedShows = showsData
    .slice()
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .reduce((acc, show) => {
      const key = `${show.date}_${show.location}_${parseBi(show.type).pl}`;
      if (!acc[key]) {
        acc[key] = { date: show.date, location: show.location, type: show.type, results: [] };
      }
      acc[key].results.push({ dogName: show.dogName, achievement: show.achievement, judge: show.judge });
      return acc;
    }, {});

  const sortedGroupedShows = Object.values(groupedShows);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(lang === 'en' ? 'en-GB' : 'pl-PL', options);
  };

  return (
    <div className="animate-fadeIn">
      <section className="my-12 md:my-20 text-center">
        <RevealHeading as="h1" text={t('shows.title')} className="text-4xl md:text-5xl font-lora text-brand-accent" />
        <Reveal as="p" delay={0.18} className="mt-4 text-lg text-brand-text-light/75 max-w-3xl mx-auto">
          {t('shows.subtitle')}
        </Reveal>
      </section>

      <div className="max-w-5xl mx-auto px-4">
        <div className="space-y-12">
          {sortedGroupedShows.map((show, index) => (
            <Reveal key={index} as="div" amount={0.12} className="bg-brand-bg-side/40 p-6 rounded-xl shadow-lg border border-brand-accent/10 transition-all duration-300 hover:border-brand-accent/30 hover:shadow-xl">
              <div className="border-b border-brand-accent/20 pb-3 mb-4">
                <p className="text-lg font-semibold text-brand-accent">{formatDate(show.date)}</p>
                <h2 className="text-2xl font-lora text-gray-100">{show.location} - <span className="font-normal">{L(show.type)}</span></h2>
              </div>
              <div className="space-y-4">
                {show.results.map((result, resultIndex) => (
                  <div key={resultIndex} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 pt-1">
                      <FaAward className="text-brand-accent/80" size={20} />
                    </div>
                    <div>
                      <p className="font-bold text-gray-200">{result.dogName}</p>
                      {L(result.achievement) && <p className="text-gray-300">{L(result.achievement)}</p>}
                      <p className="text-xs text-gray-400/80 mt-1">{t('shows.judge_label')}: {result.judge}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShowsPage;
